import { useMemo } from 'react';
import { getT, ns, useT, type Translate } from '@/i18n';
import type { VehicleKind } from '@/services/domain';
import { messages } from '../i18n';

/** «Marrakech – Aéroport» → «Marrakech» (headings use the city without the pickup point). */
export const cityShort = (city: string): string => city.split(' – ')[0] ?? city;

/** «Voitures» / «Motos» in the current language. */
export const kindLabel = (
  kind: VehicleKind,
  tc: Translate<typeof ns.common.catalogues.fr> = getT(ns.common),
): string => (kind === 'car' ? tc('cars') : tc('motos'));

/** The car / bike segmented control options, in the current language. */
export function useKindOptions(): readonly { value: VehicleKind; label: string }[] {
  const tc = useT(ns.common);
  return useMemo(
    () => [
      { value: 'car', label: tc('cars') },
      { value: 'moto', label: tc('motos') },
    ],
    [tc],
  );
}

/** «1 modèle», «14 modèles» (en «1 model», «14 models»). */
export const modelsLabel = (n: number, t: Translate<typeof messages.catalogues.fr> = getT(messages)): string =>
  t('models', { count: n });
